<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-06-16 17:28:39
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-27 17:07:10
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\SystemSettings\LabelManage\components\addClass.vue
-->
<template>
    <div>
        <!-- 新增分类 -->
        <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal='false'
        >
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
            <el-form-item label="分类名称:" prop='type'>
                <el-input v-model="form.type" maxlength="10" placeholder="请输入类别名称" style="width:90%"></el-input>
            </el-form-item>
            <el-form-item label="类别颜色:" prop="colour">
                <div class="colorChose">
                    <div class="left" :style="{background : form.colour }"></div>
                    <div class="right">
                        <el-color-picker v-model="form.colour"></el-color-picker>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="" style="margin-top:20px">
                <el-button style="width:110px;height:32px" @click="form.colour=null;form.type=''">重置</el-button>
                <el-button style="width:110px;height:32px" type="primary" @click="addUpForm" v-if="title == '新增类别'">确认</el-button>
                <el-button style="width:110px;height:32px" type="primary" @click="editUpForm" v-if="title == '编辑类别'">确认</el-button>
            </el-form-item>
        </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { apiLabel_Add,apiClass_Edit} from '../api/index'
    export default {
        data() {
            return {
                title:"新增类别",
                dialogVisible: false,
                form:{
                    colour:null,
                },
                boxColor:"",
                rules: {
                    type: [
                        { required: true, message: '请输入类别名称', trigger: 'change' },
                    ],
                    colour: [
                        { required: true, message: '请选择颜色', trigger: 'change' },
                    ],
                }
            }
        },
        methods: {
            //打开弹窗
            openDialog(){
                this.title = '新增类别'
                this.form = {}
                this.dialogVisible = true
            },
            //编辑打开弹窗
            editDialog(item){
                this.title = '编辑类别'
                this.form = {...item}
                this.dialogVisible = true
            },
            //新增保存
            addUpForm(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        apiLabel_Add({...this.form}).then(res=>{
                            if(res.code == 0){
                                this.$message({
                                    message: '新增成功',
                                    type: 'success'
                                });
                                this.dialogVisible = false
                                this.$parent.leftData()
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            //编辑保存
            editUpForm(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        apiClass_Edit({...this.form}).then(res=>{
                            if(res.code == 0){
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.dialogVisible = false
                                this.$parent.leftData()
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
        },
    }
</script>

<style lang="less" scoped>
.title{
    font-size: 18px;
    font-weight: bolder;
    color: #000;
    text-align: center;
    margin-bottom: 30px;
}
.colorChose{
    display: flex;
    .left{
        height: 30px;
        width: 60px;
        border: 1px solid #ccc;
        margin-right: 20px;
    }
}
/deep/.el-color-picker__trigger{
    height: 30px;
    width: 30px;
}

</style>